module.exports = __webpack_public_path__ + "img/roq-fm.88df45cb.png";